import { render, staticRenderFns } from "./AdminStats.vue?vue&type=template&id=35704c99&scoped=true&"
import script from "./AdminStats.vue?vue&type=script&lang=js&"
export * from "./AdminStats.vue?vue&type=script&lang=js&"
import style0 from "./AdminStats.vue?vue&type=style&index=0&id=35704c99&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35704c99",
  null
  
)

export default component.exports